import { Observable } from 'rxjs';
import { ValidationOutcomeDTO } from '../../models/validation-outcome-dto';

export abstract class CodiceFiscaleService {
	abstract validaCodiceFiscale$(codiceFiscale: string, tipoPersona: string): Observable<ValidationOutcomeDTO>;
}